import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { NewPermission } from '@core/enums/permission';
import { ReportType } from 'app/modules/reports/reports.types';

@Component({
  selector: 'chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartComponent {
  @Input() chartDef: any;
  @Input() hideEdit = false;
  @Input() hideRemove = true;
  @Input() hideTitle: false;
  @Input() fillMode = false;
  @Input() hideRefresh = true;
  @Input() isTimeSeries = false;
  @Input() height = null as string;
  @Input() overflowAuto = false;
  @Input() fields: any[] = [];
  @Output() editChart = new EventEmitter();
  @Output() removeChart = new EventEmitter();
  @Output() refreshChart = new EventEmitter();
  @Output() dataPointSelection = new EventEmitter<any>();
  NewPermission = NewPermission;

  get isFromSingleObjectReport(): boolean {
    return this.chartDef?.reportLayout?.report_type === ReportType.SingleObject;
  }

  edit(): void {
    this.editChart.emit();
  }

  remove(): void {
    this.removeChart.emit();
  }

  refresh(): void {
    this.refreshChart.emit();
  }
}
